import Hero from './components/Hero';
import Footer from './components/Footer';
import Calendar from './components/Calendar';
import Mission from './components/Mission';
import Navbar from '../../components/feature/Navbar';

const homePageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': 'https://ymctaipei.com/#webpage',
  name: '台北市青年企業研究社 YMC Taipei | 研究・友誼・服務',
  description: '台北市青年企業研究社（YMC Taipei）自1962年創立，以研究、友誼、服務三大宗旨培育青年企業家，每年舉辦30+場活動，歡迎工商菁英加入。',
  url: 'https://ymctaipei.com/',
  inLanguage: 'zh-TW',
  isPartOf: {
    '@type': 'WebSite',
    name: '台北市青年企業研究社 YMC Taipei',
    url: 'https://ymctaipei.com/',
  },
  about: {
    '@type': 'Organization',
    name: '台北市青年企業研究社',
    alternateName: 'YMC Taipei',
    foundingDate: '1962',
  },
  speakable: {
    '@type': 'SpeakableSpecification',
    cssSelector: ['h1', 'h2', '.speakable'],
  },
  dateModified: '2026-03-31',
};

const homeBreadcrumbSchema = {
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: [
    { '@type': 'ListItem', position: 1, name: '首頁', item: 'https://ymctaipei.com/' },
  ],
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      {/* React 19 document metadata hoisting */}
      <title>台北市青年企業研究社 YMC Taipei | 研究・友誼・服務 60年傳承</title>
      <meta name="description" content="台北市青年企業研究社（YMC Taipei）自1962年創立，以研究、友誼、服務培育工商青年菁英。每年30+場專業活動，涵蓋企業講座、聯誼交流與全國青商網絡，歡迎青年企業家加入。" />
      <meta name="keywords" content="台北市青年企業研究社,YMC Taipei,青企社,青年企業家,企業研究社,工商交流,企業家社群" />
      <link rel="canonical" href="https://ymctaipei.com/" />
      <meta name="last-modified" content="2026-03-31" />
      <meta property="og:title" content="台北市青年企業研究社 YMC Taipei | 研究・友誼・服務" />
      <meta property="og:description" content="自1962年創立，超過60年傳承，與工商青年菁英共同研究、交流、服務社會。每年30+場精彩活動。" />
      <meta property="og:url" content="https://ymctaipei.com/" />
      <meta property="og:type" content="website" />
      <meta name="twitter:title" content="台北市青年企業研究社 YMC Taipei | 研究・友誼・服務" />
      <meta name="twitter:description" content="自1962年創立，超過60年傳承，與工商青年菁英共同研究、交流、服務社會。" />

      {/* AEO Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homePageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homeBreadcrumbSchema) }}
      />

      <Navbar />
      <Hero />

      {/* ── About / Mission ── */}
      <Mission />

      {/* ── History ── */}
      <section id="about" className="py-16 sm:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
            <div>
              <p className="text-xs sm:text-sm font-light text-gray-500 mb-3 tracking-wider uppercase">Our History</p>
              <h2 className="text-3xl sm:text-4xl font-black text-purple-900 mb-6">60 年來的傳承與使命</h2>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  台北市青年企業研究社（YMC Taipei）是中華民國青年企業家協會台北分社，自 1962 年創立至今，已超過六十年的歷史。
                </p>
                <p>
                  歷年來，YMC Taipei 孕育了無數企業領袖與社會棟樑，以「研究、友誼、服務」三大精神為核心，持續為台灣青年企業家提供最優質的交流平台。
                </p>
                <p>
                  2026 年，在社長許政賓帶領下，YMC Taipei 持續創新，推動數位轉型與國際交流，讓青企精神傳承並發揚光大。
                </p>
              </div>
            </div>
            <div className="relative">
              <img
                src="https://public.readdy.ai/ai/img_res/fb13b5e68257eeacb27424b9fb23f090.jpg"
                alt="YMC Taipei 歷史"
                className="w-full h-72 sm:h-96 object-cover object-top rounded-2xl"
              />
              <div className="absolute -bottom-6 -left-6 bg-purple-900 text-white rounded-xl p-5 hidden sm:block">
                <div className="text-3xl font-black">60+</div>
                <div className="text-sm font-light text-purple-200 mt-1">年傳承歷史</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Annual Calendar ── */}
      <Calendar />

      <Footer />
    </div>
  );
}
